<template>
  <div class="api-detail-container">
    <div class="back">
      <span @click="$router.go(-1)"
        ><i class="iconfont icon-back"></i>返回</span
      >
    </div>
    <div class="content">
      <div class="tools">
        <el-button
          v-if="edit == false"
          type="primary"
          class="btn-edit"
          @click="editClick"
          v-hasPermi="['API接口管理', '编辑']"
          >编辑</el-button
        >
        <el-button
          v-if="edit == true"
          type="success"
          class="btn-edit"
          @click="submitForm('form')"
          >保存</el-button
        >
        <el-button
          v-if="edit == true"
          type="primary"
          class="btn-edit"
          @click="cancelClick"
          >取消编辑</el-button
        >
      </div>
      <div class="form">
        <el-form ref="form" :model="form" :rules="rules" label-width="160px">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="接口名称" prop="api_name">
                <template v-if="edit">
                  <el-input
                    v-model="form.api_name"
                    placeholder="请输入"
                  ></el-input>
                </template>
                <template v-else>
                  <el-input
                    v-model="form.api_name"
                    disabled
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="接口类型" prop="api_type">
                <template v-if="edit">
                  <el-select
                    v-model="form.api_type"
                    filterable
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in options.apiOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select
                    v-model="form.api_type"
                    disabled
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in options.apiOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="接口路径" prop="url">
                <template v-if="edit">
                  <el-input v-model="form.url" placeholder="请输入"></el-input>
                </template>
                <template v-else>
                  <el-input
                    v-model="form.url"
                    disabled
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="请求方式" prop="request_type">
                <template v-if="edit">
                  <el-select
                    v-model="form.request_type"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in options.reqOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select
                    v-model="form.request_type"
                    disabled
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in options.reqOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item label="请求参数" prop="resquest_param">
                <el-table :data="tableData" border style="width: 100%">
                  <el-table-column prop="paramsK" label="参数名" width="150">
                    <template slot-scope="scope">
                      <el-input
                        v-if="edit"
                        v-model="scope.row.paramsK"
                      ></el-input>
                      <el-input
                        v-if="!edit"
                        disabled
                        v-model="scope.row.paramsK"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="paramsV" label="参数值" width="200">
                    <template slot-scope="scope">
                      <el-input
                        v-if="edit"
                        v-model="scope.row.paramsV"
                      ></el-input>
                      <el-input
                        v-if="!edit"
                        disabled
                        v-model="scope.row.paramsV"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="desc" label="描述" width="230">
                    <template slot-scope="scope">
                      <el-input v-if="edit" v-model="scope.row.desc"></el-input>
                      <el-input
                        v-if="!edit"
                        disabled
                        v-model="scope.row.desc"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template v-if="edit" slot-scope="scope">
                      <el-button
                        @click="addClick(scope.row)"
                        type="text"
                        size="small"
                        >添加</el-button
                      >
                      <el-button
                        @click.native.prevent="
                          deleteClick(scope.$index, tableData)
                        "
                        type="text"
                        size="small"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item label="返回数据" prop="call_back_data">
                <template v-if="edit">
                  <el-input
                    type="textarea"
                    :rows="6"
                    v-model="form.call_back_data"
                    placeholder="请输入"
                  ></el-input>
                </template>
                <template v-else>
                  <el-input
                    type="textarea"
                    disabled
                    :rows="6"
                    v-model="form.call_back_data"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item label="备注" prop="remark">
                <template v-if="edit">
                  <el-input
                    type="textarea"
                    :rows="6"
                    v-model="form.remark"
                    placeholder="请输入"
                  ></el-input>
                </template>
                <template v-else>
                  <el-input
                    type="textarea"
                    disabled
                    :rows="6"
                    v-model="form.remark"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item label="完成状态" prop="status">
                <template v-if="edit">
                  <el-radio v-model="form.status" label="0">未完成</el-radio>
                  <el-radio v-model="form.status" label="1">已完成</el-radio>
                </template>
                <template v-else>
                  <el-radio disabled v-model="form.status" label="0"
                    >未完成</el-radio
                  >
                  <el-radio disabled v-model="form.status" label="1"
                    >已完成</el-radio
                  >
                </template>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { GetApiMenu, getApiDetail, updateApiData } from '@/api/api'
export default {
  data () {
    return {
      edit: false,
      form: {
        resquest_param: [],
        id: ''
      },
      rules: {
        api_name: [
          { required: true, message: '请输入接口名称', trigger: 'blur' }
        ],
        api_type: [
          { required: true, message: '请选择接口类型', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入接口路径', trigger: 'blur' }
        ],
        request_type: [
          { required: true, message: '请选择请求方式', trigger: 'blur' }
        ],
        call_back_data: [
          { required: true, message: '请输入返回数据', trigger: 'blur' }
        ]
      },
      tableData: [{
        paramsK: '',
        paramsV: '',
        desc: ''
      }],
      options: {
        apiOptions: [],
        reqOptions: [{ id: 1, name: "GET" }, { id: 2, name: "POST" }]
      }
    }
  },
  created () {
    this.form.id = this.$route.query.id
    this.initAPIDetail()
    this.initAipOptions()
  },
  methods: {
    // 编辑
    editClick () {
      this.edit = true
    },
    // 取消编辑
    cancelClick () {
      this.edit = false
    },
    deleteClick (index, rows) {
      if (rows.length > 1) {
        rows.splice(index, 1);
      }
    },
    addClick () {
      this.tableData.push({
        paramsK: '',
        paramsV: '',
        desc: ''
      })
    },
    initAPIDetail () {
      const param = { id: this.form.id }
      getApiDetail(param).then(res => {
        if (res.code == 0) {
          if (res.data.detail.api_type != null && res.data.detail.api_type != '') {
            res.data.detail.api_type = Number(res.data.detail.api_type)
          }
          if (res.data.detail.request_type != null && res.data.detail.request_type != '') {
            res.data.detail.request_type = Number(res.data.detail.request_type)
          }
          this.form = res.data.detail
          if (res.data.params.length > 0) {
            this.tableData = res.data.params
          }
        }
      })
    },
    initAipOptions () {
      GetApiMenu().then(res => {
        this.options.apiOptions = res.data
      })
    },

    // 提交
    submitForm (formName) {
      this.form.resquest_param = this.tableData
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateApiData(this.form).then(res => {
            if (res.code == 0) {
              this.$message.success('保存成功!')
              this.$router.back(-1)
            } else {
              this.$message.error(res.message)
              return
            }
          })

        } else {
          return false
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.form {
  margin-top: 20px;
}
.api-detail-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .back {
    color: #42a3df;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
    span {
      cursor: pointer;
    }
    .iconfont {
      margin-right: 10px;
    }
  }
  .content {
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 20px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #acacac;
    overflow-y: auto;
    .cell {
      display: flex;
      padding: 20px 0;
      .label {
        width: 120px;
        text-align: right;
      }
      .value {
        flex: 1;
        margin-left: 40px;
      }
      .code {
        padding: 20px 10px;
        border: 1px solid #eee;
      }
    }
  }
}
.tools {
  padding-bottom: 20px;
  .btn-edit {
    float: right;
    margin-left: 14px;
  }
}
</style>
